import { AfterViewInit, Directive, ElementRef, HostListener, OnDestroy, Input, Renderer2, inject } from '@angular/core';

import { TableKeyBindService } from './table-key-bind.service';

@Directive({
    selector: '[appTableKeyBind]',
    standalone: false
})
export class TableKeyBindDirective implements AfterViewInit, OnDestroy {
    private readonly renderer = inject(Renderer2);
    private readonly elementRef = inject(ElementRef);
    private readonly tableKeyBindService = inject(TableKeyBindService);

    @Input('appTableKeyBind')
    public enable = true;

    private mutationObserver: MutationObserver;

    @HostListener('window:keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
        if (!this.enable) {
            return;
        }

        switch (event.key) {
            case 'ArrowUp':
            case 'Up': {
                this.tableKeyBindService.focusElement(true);
                event.preventDefault();
                break;
            }
            case 'ArrowDown':
            case 'Down': {
                this.tableKeyBindService.focusElement();
                event.preventDefault();
                break;
            }
            case 'Enter': {
                this.tableKeyBindService.clickCurrentElement();
                break;
            }
        }

        event.stopPropagation();
    }

    ngAfterViewInit(): void {
        if (this.enable) {
            this.initListMutationObserver();
        }
    }

    ngOnDestroy(): void {
        if (this.mutationObserver) {
            this.tableKeyBindService.clearItems();
            this.mutationObserver.disconnect();
        }
    }

    private initListMutationObserver(): void {
        this.mutationObserver = new MutationObserver(() => {
            const keyBindItems = this.elementRef.nativeElement.querySelectorAll('tr');
            if (keyBindItems && keyBindItems.length > 0) {
                Array.from(keyBindItems)
                    .filter((item: Element) => !item.hasAttributes() || !item.attributes['tabIndex'])
                    .forEach((item: Element) => {
                        this.renderer.setAttribute(item, 'tabIndex', '0');
                    });

                this.tableKeyBindService.addItems(keyBindItems);
            }
        });
        this.mutationObserver.observe(this.elementRef.nativeElement, { childList: true });
    }
}
